import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  BigFilledButton,
  RightArrowIcon,
  BigOutlineButton,
  Div
} from "components/Base";
import { actions, getters } from "Portal/CallForPapersForm/model";
import {
  getNextButtonText,
  getNextButtonDisabled,
  getPrimaryButtonColor,
  getPrimaryButtonTextColor,
  getIsDraftButtonEnabled,
  getSecondaryButtonColor
} from "Portal/CallForPapersForm/selectors";
import Tooltip from "ui-kit/Tooltip";
import { noop } from "utils/General";
import { STEPS } from "Portal/CallForPapersForm/constants";

const SAVE_AS_DRAFT_STEPS = [STEPS.PARTICIPANTS, STEPS.SESSION];

const decorate = connect(
  state => ({
    text: getNextButtonText(state),
    disabled: getNextButtonDisabled(state),
    saving: getters.saving(state),
    searching: getters.searching(state),
    isClosed: getters.isClosed(state),
    buttonColor: getPrimaryButtonColor(state),
    buttonTextColor: getPrimaryButtonTextColor(state),
    secondaryButtonColor: getSecondaryButtonColor(state),
    activeStep: getters.activeStep(state),
    isViewingDraftSubmission: getters.isViewingDraftSubmission(state),
    savingDraft: getters.savingDraft(state),
    submissionId: getters.submissionId(state),
    isDraftButtonEnabled: getIsDraftButtonEnabled(state)
  }),
  {
    nextPage: actions.nextPage,
    saveDraft: actions.saveDraft
  }
);

const NextButton = ({
  disableShowAlert = false,
  handlers = {},
  nextPage = noop,
  saveDraft = noop,
  text = "",
  disabled = false,
  saving = false,
  searching = false,
  isClosed = false,
  buttonColor,
  buttonTextColor,
  secondaryButtonColor,
  activeStep,
  isViewingDraftSubmission,
  savingDraft,
  submissionId,
  isDraftButtonEnabled
}) => {
  const defaultDraftButtonText = isViewingDraftSubmission
    ? "Save Draft"
    : "Save as draft";
  const [savingDraftButtonText, setSavingDraftButtonText] = useState(
    defaultDraftButtonText
  );
  useEffect(() => {
    if (savingDraft) {
      setSavingDraftButtonText("Saving...");

      // after 2 seconds, change it back to "Save as draft"
      setTimeout(() => {
        setSavingDraftButtonText(defaultDraftButtonText);
      }, 2000);
    } else {
      setSavingDraftButtonText(defaultDraftButtonText);
    }
  }, [savingDraft]);

  const SaveAsDraftButton = () => (
    <BigOutlineButton
      mr={2}
      style={{
        borderRadius: "20px",
        color: secondaryButtonColor,
        borderColor: secondaryButtonColor
      }}
      onClick={
        savingDraft || saving || searching
          ? noop
          : () => {
              saveDraft();
            }
      }
      disabled={disabled || !isDraftButtonEnabled}
    >
      {savingDraftButtonText}
    </BigOutlineButton>
  );

  const ButtonFilled = () => (
    <BigFilledButton
      RightIcon={saving ? undefined : RightArrowIcon}
      style={{
        borderRadius: "20px",
        backgroundColor: buttonColor,
        color: buttonTextColor,
        borderColor: buttonColor
      }}
      onClick={
        savingDraft || saving || searching
          ? noop
          : () => {
              if (disableShowAlert) {
                handlers.setShowAlert(false);
              }
              nextPage();
            }
      }
      disabled={disabled}
    >
      {saving ? "Completing..." : text}
    </BigFilledButton>
  );

  // if saving, just return the button without tooltip
  if (saving) {
    return <ButtonFilled />;
  }

  return isClosed ? (
    <Tooltip
      tooltip={
        disabled && text === "Complete"
          ? "Closed forms cannot be edited. Please contact your event administrator to request changes."
          : null
      }
    >
      <ButtonFilled />
    </Tooltip>
  ) : (
    <Div display="row.flex-end.center">
      {(!submissionId || isViewingDraftSubmission) &&
      SAVE_AS_DRAFT_STEPS.includes(activeStep) ? (
        <SaveAsDraftButton />
      ) : null}
      <Tooltip
        tooltip={
          disabled && text === "Complete"
            ? "Mandatory fields for all speakers must be filled out before completing form."
            : null
        }
      >
        <ButtonFilled />
      </Tooltip>
    </Div>
  );
};

export default decorate(NextButton);
